/**
 * @module toQueryString
 * @since 1.4.0
 */

/**
 * Return a valid URL param value, URI encoded value following the equal sign. Empty string returns nothing
 * @private
 * @param  {String} value A value for url param value
 * @return {String}
 *
 * @example
 * equals('Hello'); // '=Hello'
 * equals('$100'); // '=%24100'
 * equals(''); // ''
 */
const equals = (value) => value === true ? '' : `=${encodeURIComponent(value)}`;

/**
 * Convert object to a string with a URL params notation.
 * @param  {Object} params Parameters object - Key value pair
 * @return {String}
 *
 * @example toQueryString({a: 1, b: true, c: 3}) // 'a=1&b&c=3'
 */
export const toQueryString = (params = {}) => Object.keys(params).map((key) => key + equals(params[key])).join('&');
